import { trainersApi } from "api/trainers/trainersApi";
import { TrainerApi } from "api/types";
import { IDropdownOption } from "components/atoms";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useTrainers = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "firstName ASC",
) => {
  const queryClient = useQueryClient();
  // const filter =
  //   groups !== undefined && groups?.length > 0 ? `groups in (${groups.map((x) => `'${x}'`).join(",")})` : "";
  const { isLoading, isFetching, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.TRAINERS_LIST(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => trainersApi.fetch(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });
  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.TRAINERS_LIST(skip, limit, searchPhrase, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, trainers: data?.data.data ?? [], total: data?.data.total ?? 0 };
};

export interface TrainerOption extends IDropdownOption {
  trainer: TrainerApi | null;
}
export const useTrainersOptions = () => {
  const { isLoading, trainers } = useTrainers(0, 1_000_000);
  const options: TrainerOption[] = trainers.map((x) => ({
    value: x.id.toString(),
    label: `${x.firstName} ${x.surname}`,
    trainer: x,
  }));

  return { isLoading, options };
};
